import { getNavigationMenus } from './selectors';

export function collapseAllMenus() {
  const collapseItems = getNavigationMenus();
  collapseItems.forEach((item) => {
    setExpandedAttribute(item, 'false');
  });
}

export function expandAllMenus() {
  const collapseItems = getNavigationMenus();
  collapseItems.forEach((item) => {
    setExpandedAttribute(item, 'true');
  });
}

function setExpandedAttribute(item: HTMLElement, value: string) {
  const container = item.parentElement!.parentElement!;
  item.setAttribute('aria-expanded', value);
  container.setAttribute('data-expanded', value);
}
